import { render, staticRenderFns } from "./NumberList.vue?vue&type=template&id=5deaf264"
import script from "./NumberList.vue?vue&type=script&lang=js"
export * from "./NumberList.vue?vue&type=script&lang=js"
import style0 from "./NumberList.vue?vue&type=style&index=0&id=5deaf264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports